import { render, staticRenderFns } from "./Description.vue?vue&type=template&id=4d7ee1b9"
import script from "./Description.vue?vue&type=script&lang=js"
export * from "./Description.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./Description.vue?vue&type=style&index=0&id=4d7ee1b9&prod&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports